<template>
  <div class="font-project-index admin-table-page" v-clickoutside:exactAreaClassName="handleUnCheck">
    <div class="table-tools">
      <div class="tt-search">
        <div class="tt-center">
          <label class="tt-title ff-title">项目组</label>
          <span class="c-search-box tt-ipt">
            <el-input v-model="projectName" placeholder="搜索项目组"></el-input>
            <el-button type="primary" circle class="c-search-btn"
              ><i class="iconfont icon-search"></i
            ></el-button>
          </span>
        </div>
      </div>
      <div class="tt-projects transition" :style="renderParentStyle">
        <ul>
          <li
            class="ttp-item"
            :class="{ active: params.projectId === item.id }"
            v-for="item in adminProjects"
            :key="item.id"
            v-text="item.name"
            @click="queryByProject(item.id)"
          ></li>
        </ul>
        <div class="ttp-cover transition" :style="renderExpandStyle">
          <i
            @click="onExpand"
            class="transition arrow-down el-icon-arrow-down"
            :class="isExpanded ? 'c-reverse' : ''"
          ></i>
        </div>
      </div>
      <div class="tt-prj">“{{ activePrjectName }}”项目字体</div>
      <div class="tt-type">
        <div>
          <label class="ttt-label"> 字体类型： </label>
          <el-select v-model="params.systemFont" @change="queryByType">
            <el-option :value="null" label="全部来源"></el-option>
            <el-option :value="true" label="公共字体"></el-option>
            <el-option :value="false" label="上传的字体"></el-option>
          </el-select>
        </div>
        <div>
          <self-radio
            v-model="isAll"
            @onChange="onCheckAll"
            :disabled="fontList.length === 0"
            >全选</self-radio
          >
          <el-button
            size="small"
            class="exactAreaClassName"
            round
            @click="onDelAll"
            :disabled="checkedIds.length === 0"
            >删除</el-button
          >
          <el-dropdown>
            <el-button
              :disabled="params.projectId === null"
              type="primary"
              size="small"
              style="margin-left: 12px"
            >
              上传字体
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openSysFont"
                >从公共字体添加</el-dropdown-item
              >
              <el-dropdown-item>
                <font-uploader-box
                  style="float: right;"
                  :projectId="params.projectId"
                  @onAdd="onFontUpload"
                >从本地上传字体</font-uploader-box>
                <!-- <font-uploader
                  type="primary"
                  :multiple="true"
                  @onAdd="onAddFont"
                  >从本地上传字体</font-uploader
                > -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div
      class="p-loading"
      v-if="pageLoading"
      v-loading="pageLoading"
      element-loading-text="拼命加载中, 请稍候"
      element-loading-spinner="el-icon-loading"
    ></div>
    <section class="table-body" v-if="fontList.length !== 0">
      <ul class="font-family-ul">
        <li
          class="font-item exactAreaClassName"
          :class="{
            'active-info': !!item.checked
          }"
          v-for="item in fontList"
          :key="item.id"
          @click.stop="toggleCheck(item)"
        >
          <div class="font-footer">
            <span class="fb-tools">
              <el-popover
                popper-class="no-arrow"
                placement="right-start"
                width="90"
                trigger="hover"
                visible-arrow="false"
              >
                <ul>
                  <li @click="showFontInfo(item)">字体信息</li>
                  <li @click="onDel(item)">删除</li>
                </ul>
                <div class="item-menu" slot="reference">
                  <i class="el-icon-more"></i>
                </div>
              </el-popover>
            </span>
            <span class="item">
              {{ item.fontFamily }}<br/>
              <span>{{ item.weight }}</span>
            </span>
          </div>
          <div class="font-body c-mask">
            <div class="fb-title" :style="{ fontFamily: item.name }">
              <img :src="item.cover" v-if="item.cover" />
              <div v-else>
                <p class="cn-name">自助设计字体</p>
                <p class="en-name">ABCDEFG1234567890</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <no-result v-else-if="!pageLoading"></no-result>
    <font-form-dialog
      title=""
      :projectId="params.projectId"
      v-model="formVisible"
      @onChange="onAddFont"
    ></font-form-dialog>
    <font-info-dialog
      v-model="fontInfoVisible"
      origin="project"
      @onAliasChange="onAliasChange"
      @onMainNamesChange="onMainNamesChange"
      :data="activeItem"
    ></font-info-dialog>
  </div>
</template>
<script>
import fontService from '../../../request/service/font-service'
import projectService from '../../../request/service/project-service'
import fontFormDialog from './font-form-dialog'
// import fontUploader from '../../template/font/font-uploader'
import fontUploaderBox from '@/views/template/font/font-uploader-box'
import util from '@/util.js'
import { language_map, platform_map } from '@/const.js'
import selfRadio from '@/views/components/radio/radio-index'
import noResult from '@/views/components/noResult'
import fontInfoDialog from './font-info-dialog'
import Clickoutside from '@/plugins/v-clickoutside'
const empty_item = { id: null, mainNames: [] }
export default {
  components: {
    fontFormDialog,
    selfRadio,
    noResult,
    fontInfoDialog,
    fontUploaderBox
    // fontUploader
  },
  directives: {
    Clickoutside
  },
  data () {
    return {
      pageLoading: false,
      isAll: false,
      formVisible: false,
      originFontList: [],
      activeItem: JSON.parse(JSON.stringify(empty_item)),
      fontInfoVisible: false,
      projectName: '',
      params: {
        name: null,
        projectId: null,
        systemFont: null
      },
      isExpanded: false,
      sysAdminProjects: []
    }
  },
  computed: {
    adminProjects () {
      let searchStr = this.projectName.toLowerCase()
      return this.sysAdminProjects.filter(item => {
        return item.name.toLowerCase().indexOf(this.projectName) > -1
      })
    },
    renderParentStyle () {
      if (!this.isExpanded) {
        return 'height: 65px'
      }
      return null
    },
    renderExpandStyle () {
      return this.isExpanded
        ? 'height: 25px'
        : 'height: 42px;line-height: 42px;'
    },
    fontList () {
      let queryStr = this.params.name
      if (!queryStr) return this.originFontList
      return this.originFontList.filter(item => {
        return (
          item.name.indexOf(queryStr) > -1 || item.alias.indexOf(queryStr) > -1
        )
      })
    },
    checkedIds () {
      let ids = []
      this.fontList.map(item => {
        if (item.checked) {
          ids.push(item.id)
        }
      })
      return ids
    },
    activePrjectName () {
      return this.params.projectId
        ? this.sysAdminProjects.find(item => item.id === this.params.projectId)
            .name
        : ''
    }
  },
  beforeRouteLeave (to, from, next) {
    this.fontInfoVisible = false
    next()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getAdminProjectList()
    },
    getData (addList) {
      this.isAll = false
      this.pageLoading = true
      fontService
        .getProjectFonts(this.params)
        .then(dataList => {
          this.originFontList = dataList
          if (addList) {
            this.originFontList.forEach(item => {
              if (addList.includes(item.id)) {
                util.setVueAttr(this, item, 'checked', true)
                // item.checked = true
              }
            })
          }
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    getAdminProjectList () {
      projectService.getAdminProjectList().then(data => {
        this.sysAdminProjects = data
        // 肯定有项目，直接取第一个项目的id进行获取字体列表
        this.params.projectId = data[0].id
        this.getData()
      })
    },
    downloadFont (list) {
      list &&
        list.forEach(font => {
          util.downloadFont(font.name, font.url)
        })
    },
    showDesc (item) {
      let isEmpty = !item.language && !item.platform
      return (
        !(item.platform === 'UNDEFINED' && item.language === 'UNDEFINED') &&
        !isEmpty
      )
    },
    formatterIcon (item) {
      let arr = []
      if (item.platform === 'COMMON' && item.language === 'COMMON') {
        arr.push(`<span>${platform_map[item.platform]}</span>`)
      } else {
        if (item.platform && item.platform !== 'UNDEFINED') {
          arr.push(
            `<span title="适用平台">${platform_map[item.platform]}</span>`
          )
        }
        if (item.language && item.language !== 'UNDEFINED') {
          arr.length > 0 && arr.push(`<span> | </span>`)
          arr.push(
            `<span title="适用语种">${language_map[item.language]}</span>`
          )
        }
      }
      return arr.join('')
    },
    clearEmptyFonts (pid) {
      let idx = this.fontList.findIndex(item => {
        return (item.projectId = pid)
      })
      if (idx > -1) {
        let fonts = this.fontList[idx].fonts || []
        if (fonts.length === 0) {
          this.fontList.splice(idx, 1)
        }
      }
    },
    onOpenForm () {
      this.formVisible = true
    },
    onAddFont (dataList) {
      this.getData(dataList)
      // fontService.setProjectFont(dataList, this.params.projectId).then(() => {
      //   this.$message.success('字体添加成功')
      //   this.formVisible = false
      //   this.getData(dataList)
      // })
    },
    onFontUpload (itemId) {
      // console.log(item, 1)
      this.getData([itemId])
    },
    onCheckAll (val) {
      this.fontList.forEach(item => {
        util.setVueAttr(this, item, 'checked', val)
      })
    },
    toggleCheck (item) {
      // console.log(111, item)
      let val = item.checked ? false : true
      util.setVueAttr(this, item, 'checked', val)
    },
    onDel (item) {
      let projectFont = false,
        configFont = false
      if (item.uploadByProj) {
        projectFont = true
      } else {
        configFont = true
      }
      let msg = this.getRemoveMsg(item.name, projectFont, configFont, 1)
      this.$confirm(msg, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.del([item.id])
        })
        .catch(item => {})
    },
    del (ids) {
      fontService.delProjectFont(this.params.projectId, ids).then(() => {
        this.originFontList = this.originFontList.filter(item => {
          return ids.indexOf(item.id) === -1
        })
        this.$message.success('删除成功')
        this.isAll = false
      })
    },
    handleUnCheck (e) {
      this.isAll = false
      this.fontList.forEach(item => {
        util.setVueAttr(this, item, 'checked', false)
      })
    },
    getRemoveMsgByName (name) {
      //针对所选的字体，区分是项目上传，还是系统配置,或者两种情况都包含
      let configFont = false,
        projectFont = false,
        len = this.checkedIds.length,
        pid = this.params.projectId
      this.fontList.forEach(item => {
        if (item.checked) {
          if (item.uploadByProj) {
            //配置页上传字体
            projectFont = true
          } else {
            //系统配置到项目字体
            configFont = true
          }
        }
      })
      return this.getRemoveMsg(name, projectFont, configFont, len)
    },
    getRemoveMsg (fontName, projectFont, configFont, fontCount = 1) {
      let fontCountMsg = fontCount < 2 ? '' : `等${fontCount}个`
      if (projectFont && configFont) {
        return `所选字体包含项目上传字体，删除后字体将消失！确定要删除“${fontName}”${fontCountMsg}字体？`
      }
      if (configFont) {
        return `确定要删除项目配置的“${fontName}”${fontCountMsg}字体？`
      }
      if (projectFont) {
        return `删除后字体将消失！确定要删除项目上传的“${fontName}”${fontCountMsg}字体？`
      }
    },
    onDelAll () {
      let ids = this.checkedIds
      let firstId = ids[0]
      let firstItem =
        this.fontList[
          this.fontList.findIndex(item => {
            return item.id === firstId
          })
        ]
      let msg = this.getRemoveMsgByName(firstItem.name)
      this.$confirm(msg, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.del(ids)
        })
        .catch(() => {})
    },
    showFontInfo (item) {
      let toggle = item.id === this.activeItem.id ? false : true
      this.fontInfoVisible = toggle
      item.mainNames = item.mainNames ? item.mainNames : []
      this.activeItem = toggle
        ? JSON.parse(JSON.stringify(item))
        : JSON.parse(JSON.stringify(empty_item))
    },
    queryByType (typeVal) {
      if (this.pageLoading) {
        return
      }
      this.params.systemFont = typeVal
      this.getData()
    },
    queryByProject (pid) {
      if (this.pageLoading) {
        return
      }
      this.params.projectId = pid
      this.getData()
    },
    queryByName (val) {
      this.params.name = val
    },
    onExpand () {
      this.isExpanded = !this.isExpanded
    },
    openSysFont () {
      this.formVisible = true
    },
    onAliasChange ({ id, alias }) {
      let idx = this.originFontList.findIndex(item => {
        return item.id === id
      })
      this.originFontList[idx].alias = alias
    },
    onMainNamesChange ({ id, mainNames }) {
      let idx = this.originFontList.findIndex(item => {
        return item.id === id
      })
      this.originFontList[idx].mainNames = mainNames
    }
  }
}
</script>
<style lang="scss">
@import './font-project-index';
</style>
